/**
 * StarRating component - displays star quality (1-5 stars).
 */

interface StarRatingProps {
    /** Current star level (1-5) */
    stars: number;
    /** Maximum stars to display (default: 5) */
    maxStars?: number;
    /** Size of stars (default: 'sm') */
    size?: 'sm' | 'md' | 'lg';
}

/**
 * Displays a star rating with filled and empty stars.
 */
export function StarRating({ stars, maxStars = 5, size = 'sm' }: StarRatingProps) {
    const sizeClasses = {
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
    };

    return (
        <span className={`inline-flex ${sizeClasses[size]}`} title={`${stars} star${stars !== 1 ? 's' : ''}`}>
            {Array.from({ length: maxStars }, (_, i) => (
                <span
                    key={i}
                    className={i < stars ? 'text-yellow-400' : 'text-gray-600'}
                >
                    ★
                </span>
            ))}
        </span>
    );
}

export default StarRating;

